import { Alert, type AlertProps } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import type { TrackingInfo } from "../common/types/trackingTypes";
import posthogStore from "../stores/posthogStore";

export interface TrackedAlertProps extends AlertProps {
   source: string;
   tracking?: TrackingInfo;
   message?: string;
}

const TrackedAlert = ({ source, tracking, message, variant, show = true, children, ...alertProps }: TrackedAlertProps) => {
   useEffect(() => {
      if (!show) {
         return;
      }

      posthogStore.captureEvent("Alert Viewed", {
         variant,
         source,
         context: tracking?.context,
         text: tracking?.text,
         message,
         url: window.location.pathname
      });
   }, [show, variant, source, tracking?.context, tracking?.text, message]);

   return (
      <Alert variant={variant} show={show} {...alertProps}>
         {children}
      </Alert>
   );
};

export default observer(TrackedAlert);
